import React from "react"
import { useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { StoreType } from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Textarea,
} from "client/components"

const Form = () => {
    const teamMember = useSelector((state: StoreType) => state.studyTeamMember.teamMemberView)
    const projectSettings = useSelector((state: StoreType) => state.project.projectSettings)
    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const { teamMembersFields } = projectSettings.study.teamMembersFieldsAssigned ? projectSettings.study : accountSettings.study

    const fields: any[] = [
        <FormGroup key="name">
            <Label>{lang.name}</Label>
            <Input type="text" value={teamMember.name} readOnly />
        </FormGroup>,
    ]
    if (teamMembersFields.company) {
        fields.push(
            <FormGroup key="company">
                <Label>{lang.company}</Label>
                <Input value={teamMember.company} readOnly />
            </FormGroup>,
        )
    }
    if (teamMembersFields.title) {
        fields.push(
            <FormGroup key="title">
                <Label>{lang.title}</Label>
                <Input type="text" value={teamMember.title} readOnly />
            </FormGroup>,
        )
    }
    if (teamMembersFields.department) {
        fields.push(
            <FormGroup key="department">
                <Label>{lang.department}</Label>
                <Input type="text" value={teamMember.department} readOnly />
            </FormGroup>,
        )
    }
    if (teamMembersFields.competence) {
        fields.push(
            <FormGroup key="competence">
                <Label>{lang.competence}</Label>
                <Input type="text" value={teamMember.competence} readOnly />
            </FormGroup>,
        )
    }
    if (teamMembersFields.phone) {
        fields.push(
            <FormGroup key="phone">
                <Label>{lang.phone}</Label>
                <Input type="text" value={teamMember.phone} readOnly />
            </FormGroup>,
        )
    }
    if (teamMembersFields.email) {
        fields.push(
            <FormGroup key="email">
                <Label>{lang.email}</Label>
                <Input type="text" value={teamMember.email} readOnly />
            </FormGroup>,
        )
    }
    if (teamMembersFields.comments) {
        fields.push(
            <FormGroup key="comments">
                <Label>{lang.comments}</Label>
                <Textarea value={teamMember.comments} readOnly />
            </FormGroup>,
        )
    }

    const maxColumnLength = fields.length / 2 + (fields.length % 2)

    const fields1 = fields.slice(0, maxColumnLength)
    const fields2 = fields.slice(maxColumnLength)

    return (
        <PageForm>
            <Row>
                {
                    (fields1.length && fields2.length)
                        ? ([
                            <Col key="fields1" xs={6}>
                                {fields1.map((field) => field)}
                            </Col>,
                            <Col key="fields2" xs={6}>
                                {fields2.map((field) => field)}
                            </Col>,
                        ])
                        : (
                            <Col xs={12}>
                                {fields.map((field) => field)}
                            </Col>
                        )
                }
            </Row>
        </PageForm>
    )
}
export default Form
